import { graphql } from "api/cms-website/generated";

import { ImageCardItemFragment } from "../elements/imageCardItem";

export const ImageCardGridFragment = graphql(/* GraphQL */ `
    fragment ImageCardGridFragment on ComponentComponentsImageCardGrid {
        id
        noMarginBottom
        imageCardGridTitle: title
        imageCardGridItems: items(pagination: { limit: 100 }) {
            ...ImageCardItemFragment
        }
    }
    ${ImageCardItemFragment}
`);
